import type { FaireProductEntity } from "../../entity_types/product";

export const p_eugbp558sn: FaireProductEntity = {
  token: "p_eugbp558sn",
  type: "product",
  name: "Rose Quartz Gemstone Feng Shui Crystal Tree (300 chips)",
  brandToken: "b_raqzmc7tej",
  brandName: "AmazeU",
  imageUrl:
    "https://cdn.faire.com/fastly/7e913f36ef0c80d72910380a1cb79533a773b68edbbf14e37301f892d1dd6c79.jpeg",
  galleryImageUrls: [],
  priceDollars: 13.72,
  description:
    "Rose Quartz Gemstone Tree Handmade Natural Gemstone Tree For Spiritual Awakening and Stress Reduction Crystal Bonsai Tree For Home Decor Bedroom Office Table Car Dashboard Vastu Gifts\n==================\n300 chips Tree\nSilver Wire Tree\nHeight: 9-11 inches\n=================\nRose Quartz Gemstones Tree is beautifully designed with the wooden base and copper wire, which can be bent in any direction as per your preferences.\n\nThis crystals and healing stone helps you to attract love in your life. Rose quartz is a perfect crystals which can be used for healing, good luck and attract love.",
  tags: [],
  msrpDollars: 27.44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:56.707Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
